import React from 'react'
import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { formatStatsValue, type StatsValue as IStatsValue } from '../../../utils'
import type { SearchNumber } from '@edge/spark/io-dashboards'

const Flex = styled('div')`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`

enum VehicleStatsLeftLabel {
    avgSaleAmount = 'Avg Sales:',
    completed = 'Completed:',
    conversion = 'Conversion:',
    ran = 'Ran:',
    sold = 'Sold:',
    sumSaleAmount = 'Sum Sales:',
    total = 'Total:',
}

interface Props {
    stats?: IStatsValue
    searchNumber?: SearchNumber
    /** Secondary stats have a different style */
    secondary?: boolean
}

export const StatsValue: React.VFC<Props> = ({ searchNumber, stats, secondary }: Props) => {
    if (!stats || !searchNumber) {
        return <Flex />
    }

    const { dataField } = searchNumber

    if (!dataField || dataField === 'none') {
        return <Flex />
    }

    return (
        <Flex>
            <Typography
                sx={{
                    color: '#888',
                    marginRight: '.15rem',
                    fontSize: 14,
                    fontWeight: 500,
                }}
            >
                {VehicleStatsLeftLabel[dataField]}
            </Typography>
            <Typography
                sx={{
                    color: '#616161',
                    fontSize: 14,
                    paddingTop: 0,
                    marginLeft: '.5rem',
                    marginRight: '.5rem',
                    marginBottom: secondary ? 0 : 0.5,
                    marginTop: secondary ? 0 : 0.5,
                }}
                variant="h5"
            >
                {formatStatsValue(stats, dataField)}
            </Typography>
        </Flex>
    )
}

export type { Props as StatsValueProps }
